 

  import httpService from '@Utils/httpService';
  
  const baseUrl = 'api/Management/facilities';
  
  export default {
    get(params) {
      return httpService.get({
        url: baseUrl,
        params,
      });
    },
    getById(companyId,id) {
      return httpService.get({
        url: `${baseUrl}/${companyId}/${id}`,
      });
    },
     update(companyId,data) {
        if (!data.id) return this.add(data);
        return httpService.put({
          url: `${baseUrl}/${companyId}/${data.id}`,
          data,
        });
      },
      add(companyId,data) {
        return httpService.post({
          url: `${baseUrl}/${companyId}`,
          data,
        });
      },
      delete(companyId, id) {
        return httpService.delete({
          url: `${baseUrl}/${companyId}/${id}`,
        });
      },
  };
  